import { render, staticRenderFns } from "./IconQA.vue?vue&type=template&id=06e21e1d&scoped=true&lang=pug&"
import script from "./IconQA.vue?vue&type=script&lang=js&"
export * from "./IconQA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e21e1d",
  null
  
)

export default component.exports